import { newSpecPage } from '@stencil/core/testing'
import { CobaltBreadcrumb } from '../cobalt-breadcrumb'

describe('cobalt-breadcrumb', () => {
  it('should render breadcrumb element', async () => {
    const page = await newSpecPage({
      components: [CobaltBreadcrumb],
      html: '<cobalt-breadcrumb></cobalt-breadcrumb>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-breadcrumb>
        <core-breadcrumb></core-breadcrumb>
      </cobalt-breadcrumb>
    `)
  })
})
